module.exports = __webpack_public_path__ + "img/hotel3_2.566e149d.png";